module.exports = __webpack_public_path__ + "img/cs_bg.0233b61f.svg";